import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";

const SPECIALISMS = [
  "Quantity Surveying",
  "Commercial, Contracts & Claims",
  "Dispute Resolution",
  "Planning",
  "Programme & Project Management",
];

export default function SubmitCV() {
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    phone: "",
    current_role: "",
    years_experience: "",
    specialism: SPECIALISMS[0],
    location: "",
    desired_region: "",
    summary: "",
    cv_link: "",
  });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/submit-cv", form);
      setDone(true);
      toast.success("Thank you — a consultant will be in touch.");
    } catch {
      toast.error("Submission failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="submit-cv-page">
      <Seo title="Submit CV" description="Submit your CV to B7 Search & Selection — confidential conversations with construction recruitment specialists." path="/submit-cv" />

      <section className="max-w-3xl mx-auto px-6 sm:px-10 pt-32 pb-12">
        <div className="overline">Candidates</div>
        <h1 className="font-serif text-5xl sm:text-6xl mt-6 leading-[1] tracking-tight" data-testid="submit-cv-headline">
          Submit your CV.
        </h1>
        <p className="text-[#5C5C5C] text-lg mt-6">
          A confidential conversation with a consultant who understands your discipline.
        </p>
      </section>

      <section className="max-w-3xl mx-auto px-6 sm:px-10 pb-24">
        {done ? (
          <div className="border border-[#E2E0D9] bg-white p-12 text-center" data-testid="cv-success-message">
            <div className="overline">Received</div>
            <h2 className="font-serif text-3xl mt-4">Thank you.</h2>
            <p className="text-[#5C5C5C] mt-4">A B7 consultant will be in touch within two working days.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-8" data-testid="cv-form">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <input className="field" placeholder="Full name *" required value={form.full_name} onChange={update("full_name")} data-testid="cv-fullname-input" />
              <input className="field" placeholder="Email *" type="email" required value={form.email} onChange={update("email")} data-testid="cv-email-input" />
              <input className="field" placeholder="Phone (optional)" value={form.phone} onChange={update("phone")} data-testid="cv-phone-input" />
              <input className="field" placeholder="Current job title" value={form.current_role} onChange={update("current_role")} data-testid="cv-role-input" />
              <input className="field" placeholder="Years of experience" value={form.years_experience} onChange={update("years_experience")} data-testid="cv-experience-input" />
              <select className="field" value={form.specialism} onChange={update("specialism")} data-testid="cv-specialism-select">
                {SPECIALISMS.map((s) => <option key={s}>{s}</option>)}
              </select>
              <input className="field" placeholder="Current location" value={form.location} onChange={update("location")} data-testid="cv-location-input" />
              <input className="field" placeholder="Desired region (UK / Europe / Middle East)" value={form.desired_region} onChange={update("desired_region")} data-testid="cv-region-input" />
            </div>
            <input className="field" placeholder="Link to CV (Drive, Dropbox, LinkedIn)" value={form.cv_link} onChange={update("cv_link")} data-testid="cv-link-input" />
            <textarea className="field" placeholder="Brief professional summary" value={form.summary} onChange={update("summary")} data-testid="cv-summary-input" />
            <button type="submit" disabled={loading} className="btn-primary" data-testid="cv-submit-button">
              {loading ? "Submitting..." : "Submit CV"} <ArrowRight size={16} />
            </button>
          </form>
        )}
      </section>
    </div>
  );
}
